import React from 'react';
import { Button, Form } from 'react-bootstrap';

import { ProgramTypeAndSubTypeLabel, ReviewStatusLabels } from 'utils/enums';

import DatePicker from 'components/elements/FormInput/date/DatePicker';
import Select from 'components/elements/FormInput/select/Select';

import FilterEnum from './data';

type FilterValue = any;

interface ExtraFiltersProps {
  filters: Record<string, FilterValue>;
  onFilter: (key: string, value: FilterValue) => void;
  onClearFilter: () => void;
}

interface FilterElementProps {
  label: string;
  width?: string;
  clipContent?: boolean;
  children: React.ReactNode;
}

const CONTROL_HEIGHT = '38px';

const selectMenuProps = {
  menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
  menuPosition: 'fixed' as const,
  styles: {
    menuPortal: (base: Record<string, unknown>) => ({ ...base, zIndex: 9999 }),
  },
};

const FilterElement: React.FC<FilterElementProps> = ({
  label,
  width = '13rem',
  clipContent = false,
  children,
}) => (
  <div
    style={{
      width,
      flexShrink: 0,
      minWidth: 0,
      ...(clipContent ? { overflow: 'hidden' } : {}),
    }}
  >
    <b className="d-block mb-1">{label}</b>
    {children}
  </div>
);

interface AlignedControlProps {
  children: React.ReactNode;
}

const AlignedControl: React.FC<AlignedControlProps> = ({ children }) => (
  <div style={{ flexShrink: 0 }}>
    <b className="d-block mb-1 invisible" aria-hidden="true">&nbsp;</b>
    <div
      className="d-flex align-items-center"
      style={{ minHeight: CONTROL_HEIGHT }}
    >
      {children}
    </div>
  </div>
);

const ExtraFilters: React.FC<ExtraFiltersProps> = ({
  filters,
  onFilter,
  onClearFilter,
}) => (
  <div
    className="d-flex align-items-end justify-content-between flex-wrap w-100"
    style={{ columnGap: '1rem', rowGap: '1rem' }}
  >
    <FilterElement label="Program Type">
      <Select
        isClearable
        {...selectMenuProps}
        options={Object.entries(ProgramTypeAndSubTypeLabel).map(([value, label]) => ({
          value,
          label,
        }))}
        value={filters[FilterEnum.type]}
        onChange={(value) => onFilter(FilterEnum.type, value)}
      />
    </FilterElement>
    <FilterElement label="Active Status">
      <Select
        isMulti
        isClearable
        {...selectMenuProps}
        options={Object.entries(ReviewStatusLabels).map(([value, label]) => ({
          value,
          label,
        }))}
        value={filters[FilterEnum.status]}
        onChange={(value) => onFilter(FilterEnum.status, value)}
      />
    </FilterElement>
    <FilterElement label="Expired From" width="10.5rem" clipContent>
      <DatePicker
        fullWidth
        isClearable
        selected={filters[FilterEnum.from]}
        onChange={(value) => onFilter(FilterEnum.from, value)}
      />
    </FilterElement>
    <FilterElement label="Expired To" width="10.5rem" clipContent>
      <DatePicker
        fullWidth
        isClearable
        selected={filters[FilterEnum.to]}
        onChange={(value) => onFilter(FilterEnum.to, value)}
      />
    </FilterElement>
    <AlignedControl>
      <Form.Check
        type="checkbox"
        label="Sample applications"
        className="mb-0"
        style={{ whiteSpace: 'nowrap' }}
        checked={filters[FilterEnum.isSample] === true}
        onChange={(e) => onFilter(FilterEnum.isSample, e.target.checked || null)}
      />
    </AlignedControl>
    <AlignedControl>
      <Button variant="secondary" onClick={onClearFilter}>
        Clear
      </Button>
    </AlignedControl>
  </div>
);

export default ExtraFilters;
